/**
 * Created by yqr on 2018/4/13.
 * 设置api请求的baseURL
 * 实际项目中建议该文件不纳入版本管理
 */
export default {
  // baseURL: 'http://shpic-api.szwawo.com',
  baseURL: 'https://s.xingchaoyiqing.com',
  isDev: false
}



// WEBPACK FOOTER //
// ./src/api/env.js